export function flatten(array: JSX.Element[][]) {
  return array.reduce((accumulator, value) => accumulator.concat(value), [])
}

export function shuffle(array: JSX.Element[][]) {
  const result = flatten(array)

  let currentIndex = result.length,
    temporaryValue,
    randomIndex

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    temporaryValue = result[currentIndex]
    result[currentIndex] = result[randomIndex]
    result[randomIndex] = temporaryValue
  }

  return result
}

function stripQuotes(s: string) {
  return s.replace('"', '')
}

export function alphabetical(array: JSX.Element[][]) {
  const result = flatten(array)

  return result.sort((a: JSX.Element, b: JSX.Element) =>
    stripQuotes(a.key! as string).localeCompare(stripQuotes(b.key as string))
  )
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
